import { FlecxModalService } from '@projects/shared/src/app/services/flecx-modal.service';
import { Injectable, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { AuthenticationService } from '@app/core';
import { sortList } from '@projects/shared/src/app/utils/helper';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { noLeadingOrTrailingSpacesValidator } from '@app/core/helpers';
import { FeatureResponse, FeaturesList } from '../features/interfaces/User/feature';
import { UserApiService } from './user-api.service';
import { DropDownType } from '../features/interfaces/User/dropDown';
import { CampaignUpdateModal } from '../features/interfaces/User/campaign';
import { AppConfigurationService } from '@projects/shared/src/app/services/app.configuration.service';
@Injectable({
  providedIn: 'root',
})
export class UserService implements OnDestroy {
  defaultReqOptions = { headers: new HttpHeaders({ hideLoader: 'true' }) };
  //* Variables ---- Start ----
  subscriptions = new Array<Subscription>();
  dialingCountries: Array<DropDownType> = [
    { lable: 'AU', value: 'AU' },
    { lable: 'GB', value: 'GB' },
    { lable: 'CA', value: 'CA' },
    { lable: 'NZ', value: 'NZ' },
    { lable: 'US', value: 'US' },
  ];
  clientCampaigns: any = [];
  clientCampaignsDropDown: Array<DropDownType> = [];
  priorityDropDown: Array<DropDownType> = [
    { lable: 'None', value: '0' },
    { lable: 'Highest', value: '1' },
    { lable: 'High', value: '2' },
    { lable: 'Medium', value: '3' },
    { lable: 'Low', value: '4' },
    { lable: 'Lowest', value: '5' },
  ];
  campaignSource: Array<string> = ['Primary', 'Secondary', 'Tertiary', 'Quaternary '];
  listOfReportToSup: any = [];
  listOfUserRoles: any = [];
  currentUserClientId: string = '';
  campaignUpdateModal: CampaignUpdateModal = {
    isModalOpen: false,
    isSingleUser: false,
    isMultiUsers: false,
    userIds: [],
    userNames: [],
    clientCampaignsDropDown: [],
    agentCampaignsDropDown: [],
    supervisorCampaignsDropDown: [],
    supervisorCampaigns: [],
    agentCampaigns: [],
  };
  priorityUpdateModal: CampaignUpdateModal = {
    isModalOpen: false,
    isSingleUser: false,
    isMultiUsers: false,
    userIds: [],
    userNames: [],
    clientCampaignsDropDown: [],
    agentCampaigns: [],
    supervisorCampaigns: [],
    agentCampaignsDropDown: [],
    supervisorCampaignsDropDown: []
  };
  bulkCampaignUpdateModal = {
    isModalOpen: false,
    step: 1 as 1 | 2 | 3,
    file: null as File | null,
    fileName: '',
    fileSize: '',
    totalRows: 0,
    validCount: 0,
    errorCount: 0,
    rows: [] as Array<{
      rowNumber: number;
      agentId: string;
      userName?: string;
      campaigns: string[];
      status: 'valid' | 'error';
      message: string;
    }>,
    skipErrors: true,
    isLoading: false,
    isValidating: false,
    summarySuccessCount: 0,
    summarySkippedCount: 0,
  };
  teamStructureModal = {
    isModalOpen: false,
    step: 1 as 1 | 2 | 3,
    file: null as File | null,
    fileName: '',
    fileSize: '',
    totalRows: 0,
    validCount: 0,
    errorCount: 0,
    rows: [] as Array<{
      rowNumber: number;
      agentId: string;
      agentName?: string;
      supervisorFleCxId: string;
      supervisorName?: string;
      status: 'valid' | 'error';
      message: string;
    }>,
    skipErrors: true,
    isLoading: false,
    isValidating: false,
    summarySuccessCount: 0,
    summarySkippedCount: 0,
  };
  isUserListUpdated = new BehaviorSubject<{ isUpdated?: boolean }>({ isUpdated: false });
  userPasswordToBeReset: { firstName: string; id: string } = { firstName: '', id: '' };
  //* placing this variable here because of the re-render and api hit
  //* for next and prev button
  featuresList: Array<FeaturesList> = [];
  rowFeaturesList: Array<FeaturesList> = [];
  selectedFeaturesIds: Array<string> = [];
  //* Variables ---- End ----

  //* User C.R.U Form
  initialUserFormValue = {
    firstName: '',
    lastName: '',
    userName: '',
    pseudoName: '',
    profilePic: '',
    location: '',
    email: '',
    ibexId: '',
    ibexPassword: '',
    designation: '',
    dialingCountries: '',
    reportTo: '',
    priority: 0,
    campaigns: '',
    isEnabled: true,
  };
  initialUsersCamapignFormValue = {
    campaigns: '',
  };
  initialUsersPriorityFormValue = {
    priority: '',
  };
  userForm: FormGroup = this.createUserForm();
  userCampaignForm: FormGroup = this.createUserCampaignForm();
  userPriorityForm: FormGroup = this.createUserPriorityForm(); 
  userAssignedApps: Array<any> = [];
  userApps: Array<any> = [];
  userAssignedSelectedApps:number=0;
  userPrimaryApps: Array<any> = [];  
  userPayload:any = {
       assignedApps: [],
       roleIds: [],
       rolesLabel: [],
       supervisorCenters: [],
       userCampaigns: [],
       features:[],
       agentCenter:'',
       assignedCenters:[],
       campaignInfo: { Agent: { center: '', campaigns: [],centerLabel:'' }, Supervisor: { centers: [], campaigns: [],centerLabel:'' } }
  };
  isCustomizeFeature:boolean = false;
  userCloneModal = {
    isModalOpen: false,
    inputData:{
      userName:'',
      isAgent:false,
      isSupervisor:false,
      cloneId:'',
      createdBy:''
    },
    $selectUser: new BehaviorSubject(false),
  };
  constructor(
    public authService: AuthenticationService,
    private fb: FormBuilder,
    public httpClient: HttpClient,
    public toastService: ToastService,
    private location: Location,
    private flecxModalService: FlecxModalService,
    private userApisService: UserApiService,
    private appConfig: AppConfigurationService
  ) {
    //* Initializer
    // this.userForm = this.createUserForm();
    this.clientCampaigns = this.authService.getAllClientCampaigns();
    this.clientCampaignsDropDown =
      this.clientCampaigns?.map((d: any) => ({
        lable: d.Code,
        value: d.Code,
      })) ?? [];
    this.currentUserClientId = this.authService.getClientId();

    this.subscriptions.push(
      // this.flecxModalService.onModalAction.subscribe(({ type }) => {
      //   this.onUserPasswordReset(type);
      // })
    );
  }

  createUserForm() {
    return this.fb.group({});
  }

  createUserCampaignForm() {
    return this.fb.group({
      campaigns: ['', [Validators.required]],
    });
  }

  createUserPriorityForm() {
    return this.fb.group({
      priority: ['', [Validators.required]],
    });
  }

  // Access formcontrols getter & setters
  getCampaignFormField(fieldName: string) {
    return this.userCampaignForm.get(fieldName);
  }
  getUserFormField(fieldName: string) {
    return this.userForm.get(fieldName);
  }
  setUserFormField(fieldName: string, filedData: any) {
    this.userForm.controls[fieldName].setValue(filedData);
  }
  clearUserForm(emitEvent: boolean = false) {
    //this.userForm.reset(this.initialUserFormValue, { emitEvent: emitEvent });
    this.userForm = this.createUserForm();
  }
  clearUsersCampaignForm(emitEvent: boolean = false) {
    this.userCampaignForm.reset(this.initialUsersCamapignFormValue, { emitEvent: emitEvent });
  }
  clearUsersPriorityForm(emitEvent: boolean = false) {
    this.userPriorityForm.reset(this.initialUsersPriorityFormValue, { emitEvent: emitEvent });
  }
  checkUserFormFieldValidation(fieldName: string) {
    return (
      this.userForm.get(fieldName)?.invalid &&
      (this.userForm.get(fieldName)?.dirty || this.userForm.get(fieldName)?.touched)
    );
  }

  public getFieldError(fieldName: string, form: FormGroup = this.userForm): string | null {
    const phoneNumber = ['phone_number', 'PhoneNumber'];
    const validationMessages: any = {
      required: 'This field is required',
      email: 'Please enter a valid email address',
      minlength: (error: any) =>
        `Minimum ${error.requiredLength} characters required (currently ${error.actualLength})`,
      maxlength: (error: any) =>
        `Maximum ${error.requiredLength} characters allowed`,
      pattern: (error: any, fieldname:string) => { 
        const match = error.requiredPattern.match(/\{(\d+),(\d+)\}/);
        if (match) {
          const min = match[1];
          const max = match[2];
          return phoneNumber.includes(fieldname) ? `Phone number must start with + and contain ${min}–${max} digits`: `Must be between ${min} and ${max} characters (special character not allowed)`;
        }
        return 'Invalid format';
      },

      min: (error: any) =>
        `Minimum value is ${error.min}`,

      max: (error: any) =>
        `Maximum value is ${error.max}`
    };
    const control = form.get(fieldName);

    if (!control || !control.errors || !(control.dirty || control.touched)) {
      return null;
    }

    const errors = control.errors;
    const firstErrorKey = Object.keys(errors)[0];
    const errorValue = errors[firstErrorKey];

    const message = validationMessages[firstErrorKey];

    return typeof message === 'function'
      ? message(errorValue, fieldName)
      : message;
  }

  public cancelUserSetup(){
    this.resetUser();
    this.goBack();
  }
  checkCampaignFormFieldValidation(fieldName: string) {
    return (
      this.userCampaignForm.get(fieldName)?.invalid &&
      (this.userCampaignForm.get(fieldName)?.dirty || this.userCampaignForm.get(fieldName)?.touched)
    );
  }
  checkPriorityFormFieldValidation(fieldName: string) {
    return (
      this.userCampaignForm.get(fieldName)?.invalid &&
      (this.userCampaignForm.get(fieldName)?.dirty || this.userCampaignForm.get(fieldName)?.touched)
    );
  }
  isFormValid(form: FormGroup): boolean {
    //* The validation status of the control. There are four possible validation status values:

    // VALID: This control has passed all validation checks.
    // INVALID: This control has failed at least one validation check.
    // PENDING: This control is in the midst of conducting a validation check.
    // DISABLED: This control is exempt from validation checks.

    return form.disabled ? true : form.valid;
  }

  isUserFormValid() {
    this.userForm.markAllAsTouched();
    return this.isFormValid(this.userForm);
  }

  isUserCampaignFormValid() {
    this.userCampaignForm.markAllAsTouched();
    return this.isFormValid(this.userCampaignForm);
  }

  isUserPriorityFormValid() {
    this.userPriorityForm.markAllAsTouched();
    return this.isFormValid(this.userPriorityForm);
  }

  campaignDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.getUserFormField('campaigns')?.value, event.previousIndex, event.currentIndex);
  }
  ListCampaignDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.getCampaignFormField('campaigns')?.value, event.previousIndex, event.currentIndex);
  }

  agentCampaignDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.campaignUpdateModal.agentCampaignsDropDown, event.previousIndex, event.currentIndex);
  }

  getCampaignByCode(code: string) {
    return this.clientCampaigns.find((c: any) => c.Code === code);
  }
  
  public resetUser() {
    this.featuresList = [];
    this.userAssignedApps = [];
    this.userApps = [];
    this.userAssignedSelectedApps = 0;
    this.userPrimaryApps = [];
    this.userPayload = {
      assignedApps: [],
      roleIds: [],
      rolesLabel: [],
      supervisorCenters: [],
      userCampaigns: [],
      features: [],
      agentCenter: '',
      assignedCenters: [],
      campaignInfo: { Agent: { center: '', campaigns: [],centerLabel:'' }, Supervisor: { centers: [], campaigns: [],centerLabel:'' } },
    }
    this.isCustomizeFeature = false
    this.selectedFeaturesIds = [];
    this.listOfReportToSup = [];
    this.listOfUserRoles = [];
  }
  
  onSaveUser() {
    if (this.isUserFormValid()) {
      const { assignedApps, roleIds, userCampaigns, features,  campaignInfo } = this.userPayload;

      let payload = {
        FirstName: this.userForm.controls['firstName'].value,
        LastName: this.userForm.controls['lastName'].value,
        //RoleName: this.listOfUserRoles.find((r: any) => r.Id === this.userForm.controls['designation'].value).Name,
        RoleIds: roleIds,
        FeatureIds: features,
        ReportTo: this.userForm.controls['reportTo'].value,
        // Location: this.userForm.controls['location'].value,
        PseudoName: this.userForm.controls['pseudoName'].value,
        ProfilePic: this.userForm.controls['profilePic'].value,
        Email: this.userForm.controls['email'].value,
        PhoneNumber: this.userForm.controls['phone_number'].value,
        Username: this.userForm.controls['userName'].value,
        ClientId: this.currentUserClientId,
        //IbexUserId: this.userForm.controls['ibexId'].value,
        DefaultLanguage: 'en',
        DialingCountries: this.userForm.controls['dialingCountries'].value,
        CreatedBy: this.authService.getUserId(),
        Priority: +this.userForm.controls['priority'].value,
        PrimaryApp: this.userForm.controls['primaryApp'].value,
        Settings: {
          TourGuide: false,
          IbexDialer: {
            UserId: this.userForm.controls['ibexId'].value,
            Password: this.userForm.controls['ibexPassword'].value
          }
        },
        //this.userForm.controls['location'].value
        UserCampaigns: userCampaigns,
        AssignedApps: assignedApps,
        //  SupervisorCenters: supervisorCenters,
        //  AgentCenter:agentCenter,
        CampaignInfo: campaignInfo
      };
      this.userApisService.postUser(payload).subscribe({
        next: (data: any) => {
          // Handle next value
          if (data.id) {
            this.toastService.success('User Created Successfully');
            this.clearUserForm();
            this.goBack();
            this.resetUser()
          }
        },
        error: (error: any) => {
          // Handle error
          console.log(new Date().toLocaleString() + '  ➤  postUser next : ', error);
        },
        complete: () => {
          // Handle complete
          // No errors, route to new page here
        },
      });
    } else {
      //* Show pop-up or do nothing
      this.toastService.warning('Invalid form please check all fields');
    }
  }
  onUpdateUser(userId: string) {
    if (this.isUserFormValid()) {
      const { assignedApps, roleIds, userCampaigns, supervisorCenters, features, agentCenter, campaignInfo } = this.userPayload;

      let payload = {
        Id: userId,
        FirstName: this.userForm.controls['firstName'].value,
        LastName: this.userForm.controls['lastName'].value,
        //RoleName: this.listOfUserRoles.find((r: any) => r.Id === this.userForm.controls['designation'].value).Name,
        RoleIds: roleIds,
        FeatureIds: features,
        ReportTo: this.userForm.controls['reportTo'].value,
        // Location: this.userForm.controls['location'].value,
        PseudoName: this.userForm.controls['pseudoName'].value,
        ProfilePic: this.userForm.controls['profilePic'].value,
        Email: this.userForm.controls['email'].value,
        PhoneNumber: this.userForm.controls['phone_number'].value,
        //IbexUserId: this.userForm.controls['ibexId'].value,
        DialingCountries: this.userForm.controls['dialingCountries'].value,
        ModifiedBy: this.authService.getUserId(),
        UserCampaigns: userCampaigns,
        Priority: +this.userForm.controls['priority'].value,
        Settings: {
          IbexDialer: {
              UserId: this.userForm.controls['ibexId'].value,
              Password: this.userForm.controls['ibexPassword'].value
          }
        },
        primaryApp: this.userForm.controls['primaryApp'].value,
        AssignedApps: assignedApps,
        SupervisorCenters: supervisorCenters,
         AgentCenter:agentCenter,
         CampaignInfo:campaignInfo
      };
      this.userApisService.updateUser(payload).subscribe({
        next: (data: any) => {
          // Handle next value
          //if (data.id) {
          this.toastService.success('User Updated Successfully');
          this.clearUserForm();
          this.goBack();
          this.resetUser();
        },
        error: (error: any) => {
          // Handle error
          console.log(new Date().toLocaleString() + '  ➤  updateUser next : ', error);
        },
        complete: () => {
          // Handle complete
          // No errors, route to new page here
        },
      });
    } else {
      //* Show pop-up or do nothing
      this.toastService.warning('Invalid form please check all fields');
    }
  }
  public onUpdateUserCampaigns() {
    const agentCampaigns: Array<any> = [];
    const supervisorCampaigns: Array<any> = [];
    if (this.campaignUpdateModal.agentCampaignsDropDown.length && !this.campaignUpdateModal.agentCampaigns.length) {
      this.toastService.error(`Please select at least one campaign program from agent`);
      return
    }
    if (this.campaignUpdateModal.supervisorCampaignsDropDown.length && !this.campaignUpdateModal.supervisorCampaigns.length) {
      this.toastService.error(`Please select at least one campaign program from supervisor`);
      return
    }
    this.campaignUpdateModal.supervisorCampaigns.forEach((value: string, index: number) => {
      const campaignByCode = this.getCampaignByCode(value);
      const obj = {
        Name: campaignByCode.Name,
        Id: campaignByCode.Id,
        Code: campaignByCode.Code,
        IsPrimary: index === 0
      }
      supervisorCampaigns.push(obj);
    });
    this.campaignUpdateModal.agentCampaigns.forEach((value: string, index: number) => {
      const campaignByCode = this.getCampaignByCode(value);
      const obj = {
        Name: campaignByCode.Name,
        Id: campaignByCode.Id,
        Code: campaignByCode.Code,
        IsPrimary: index === 0
      }
      agentCampaigns.push(obj);
    });
    let payload = {
      UserId: this.campaignUpdateModal.userIds[0],
      AgentCampaigns: agentCampaigns,
      SupervisorCampaigns: supervisorCampaigns,
    };
    this.userApisService.updateUsersCampaign(payload).subscribe({
      next: (data: any) => {
        // Handle next value

        this.toastService.success('Campaign Updated Successfully');
        this.closeCampaignUpdateModal();
        this.isUserListUpdated.next({ isUpdated: true });
      },
      error: (error: any) => {
        this.toastService.error('Something went wrong!');
        // Handle error
        console.log(new Date().toLocaleString() + '  ➤  updateUsersCampaign next : ', error);
      },
      complete: () => {
        // Handle complete
        // No errors, route to new page here
      },
    });
  }

  onUpdateUserPriority() {
    if (this.isUserPriorityFormValid()) {
      //* Make data for API request
      // console.log(new Date().toLocaleString() + '  ➤  Form Valid : ', this.isFormValid(this.userPriorityForm), this.userPriorityForm.value);

      let usersPriority = +this.userPriorityForm.controls['priority'].value;

      let payload = {
        UserIds: this.priorityUpdateModal.userIds,
        Priority: usersPriority,
      };
      this.userApisService.updateUsersPriority(payload).subscribe({
        next: (data: any) => {
          // Handle next value
          this.toastService.success('Priority Updated Successfully');
          // console.log(new Date().toLocaleString() + '  ➤  updateUsersPriority next : ', data);
          this.closePriorityUpdateModal();
          this.isUserListUpdated.next({ isUpdated: true });
        },
        error: (error: any) => {
          this.toastService.error('Something went wrong!');
          // Handle error
          console.log(new Date().toLocaleString() + '  ➤  updateUsersPriority next : ', error);
        },
        complete: () => {
          // Handle complete
          // No errors, route to new page here
        },
      });
      // console.log(new Date().toLocaleString() + '  ➤  Payload ==> ', payload);
    } else {
      //* Show pop-up or do nothing
      this.toastService.warning('Invalid form please check all fields');
      // console.log(new Date().toLocaleString() + '  ➤  Form Invalid : ', this.isFormValid(this.userPriorityForm), this.userPriorityForm.value);
    }
    // console.log(new Date().toLocaleString() + '  ➤  onUpdateUserPriority() ', this.userPriorityForm.controls);
  }
  onUserPasswordReset(type: string) {
    if (type === 'Reset_Password_Yes') {
      this.userApisService.resetUserPassword(this.userPasswordToBeReset.id).subscribe({
        next: (data: any) => {
          // Handle next value
          let tempName = this.userPasswordToBeReset.firstName;
          this.toastService.success(`Password Reset Successfully for ${tempName}`);
          this.userPasswordToBeReset = { id: '', firstName: '' };
          // if (data.id) {
          //   this.toastService.success('User Created Successfully');
          //   console.log(new Date().toLocaleString() + '  ➤  postUser next : ', data);
          //   this.clearUserForm();
          //   this.goBack();
          // }
        },
        error: (error: any) => {
          // Handle error
          console.log(new Date().toLocaleString() + '  ➤  onUserPasswordReset error : ', error);
          this.toastService.error(`Spmething went wrong`);
          this.userPasswordToBeReset = { id: '', firstName: '' };
        },
        complete: () => {
          // Handle complete
          // No errors, route to new page here
        },
      });
    } else if (type === 'Reset_Password_No') {
      this.userPasswordToBeReset = { id: '', firstName: '' };
    }
  }
  onCancelUser() {
    this.clearUserForm();
    this.goBack();
  }
  goBack(): void {
    this.location.back();
  }
  clearFormValidationsForOnlyCampaignUpdate() {
    this.userForm.controls['reasons'].clearValidators();
    this.userForm.controls['reasons'].updateValueAndValidity();
  }
  openCampaignUpdateModalMultiUsers(users: any) {
    this.closePriorityUpdateModal();
    const userIds = users.map((user: any) => user._id);
    //* Manage Bits
    this.campaignUpdateModal.isModalOpen = true;
    this.campaignUpdateModal.isMultiUsers = true;
    this.campaignUpdateModal.isSingleUser = false;
    this.campaignUpdateModal.userIds = userIds;
    this.campaignUpdateModal.userNames = users.map((user: any) => user.FirstName);
  }

  openPriorityUpdateModalMultiUsers(users: any) {
    this.closeCampaignUpdateModal();
    const userIds = users.map((user: any) => user._id);
    //* Manage Bits
    this.priorityUpdateModal.isModalOpen = true;
    this.priorityUpdateModal.isMultiUsers = true;
    this.priorityUpdateModal.isSingleUser = false;
    this.priorityUpdateModal.userIds = userIds;
    this.priorityUpdateModal.userNames = users.map((user: any) => user.FirstName);
  }
  openCampaignUpdateModalSingleUser(_id: string) { 
    this.closePriorityUpdateModal();
    // console.log(new Date().toLocaleString() + '  ➤  _id ==> ', _id);
    this.campaignUpdateModal.isModalOpen = true;
    this.userApisService.getUserById(_id).subscribe({
      next: (data: any) => {
        const supervisorCampaignsDropDown:Array<string> = [];
        const agentCampaignsDropDown:Array<string> = [];
        this.campaignUpdateModal.agentCampaigns = [];
        this.campaignUpdateModal.supervisorCampaigns = [];
        this.campaignUpdateModal.agentCampaignsDropDown = [];
        this.campaignUpdateModal.supervisorCampaignsDropDown = [];

        if(data.CampaignInfo?.Agent?.Center){
            agentCampaignsDropDown.push(data.CampaignInfo.Agent.Center.Code);
            data.CampaignInfo.Agent.Campaigns.forEach((center:any) => this.campaignUpdateModal.agentCampaigns.push(center.Code));
        }
        if(data.CampaignInfo?.Supervisor?.Centers){
          data.CampaignInfo.Supervisor.Centers.forEach((center:any)=> supervisorCampaignsDropDown.push(center.Code));
          data.CampaignInfo.Supervisor.Campaigns.forEach((center:any) => this.campaignUpdateModal.supervisorCampaigns.push(center.Code));
        }
        const mapping = this.appConfig.getByIdentifier('CenterCampaignsMapping').Fields;
        // this.campaignUpdateModal.clientCampaignsDropDown = mapping
        //   .filter((item: any) => data.AssignedCenters.includes(item.Center))
        //   .flatMap((item: any) => item.Campaigns)
        //   .map((campaign: any) => ({
        //     lable: campaign.Code,
        //     value: campaign.Code
        //   }));
        this.campaignUpdateModal.agentCampaignsDropDown = mapping
          .filter((item: any) => agentCampaignsDropDown.includes(item.Center))
          .flatMap((item: any) => item.Campaigns)
          .map((campaign: any) => ({
            lable: campaign.Code,
            value: campaign.Code
          }));
        this.campaignUpdateModal.supervisorCampaignsDropDown = mapping
          .filter((item: any) => supervisorCampaignsDropDown.includes(item.Center))
          .flatMap((item: any) => item.Campaigns)
          .map((campaign: any) => ({
            lable: campaign.Code,
            value: campaign.Code
          }));
        this.campaignUpdateModal.userNames.push(data?.FirstName);

        this.campaignUpdateModal.isModalOpen = true;
        this.campaignUpdateModal.isSingleUser = true;
        this.campaignUpdateModal.isMultiUsers = false;
        this.campaignUpdateModal.userIds = [_id];
      },
      error: (error: any) => {
        // Handle error
      },
      complete: () => {
        // Handle complete
        // No errors, route to new page here
      },
    });
  }

  openPriorityUpdateModalSingleUser(userObj: any) {
    this.closeCampaignUpdateModal();
    // id: ctx.row['_id'], priority: ctx.row['Priority'], firstName: ctx.row['FirstName']
    // console.log(new Date().toLocaleString() + '  ➤  userObj ==> ', userObj);
    // console.log(new Date().toLocaleString() + '  ➤  priority ==> ', priority);

    this.priorityUpdateModal.isModalOpen = true;
    this.priorityUpdateModal.userNames.push(userObj.firstName);
    //this.userPriorityForm.reset({ priority: userObj.priority }, { emitEvent: false });
    this.userPriorityForm.controls['priority'].setValue(userObj.priority.toString() ?? '0');
    //* Open Modal when data is fetched
    this.priorityUpdateModal.isModalOpen = true;
    this.priorityUpdateModal.isSingleUser = true;
    this.priorityUpdateModal.isMultiUsers = false;
    this.priorityUpdateModal.userIds = [userObj.id];
  }

  getUserRoles() {
    //* Fetch Roles
    this.userApisService.getUserRoles(this.currentUserClientId).subscribe({
      next: (data: any) => {
        // Handle next value
        // Step 1: find shared IDs
        const sharedIds = data
          .map((item:any) => item.Features)
          .reduce((acc:any, curr:any) => acc.filter((id:any) => curr.includes(id)));

        // Step 2: remove shared IDs and add sharedfea
        const result = data.map((item:any) => ({
          ...item,
          Features: item.Features.filter((id:any) => !sharedIds.includes(id)),
          sharedFeatures: sharedIds
        }));
        this.listOfUserRoles = result;
      },
      error: (error: any) => {
        // Handle error
      },
      complete: () => {
        // Handle complete
        // No errors, route to new page here
      },
    });
  }
  getReportToUsers() {
    //* Fetch Users
    this.userApisService.getAllAgents().subscribe({
      next: (data: any) => {
        // Handle next value
        // Sort the list by Email
        sortList(data, true, { key: 'Email', asc: true });

        this.listOfReportToSup = data;
      },
      error: (error: any) => {
        // Handle error
      },
      complete: () => {
        // Handle complete
        // No errors, route to new page here
      },
    });
  }

  /**
   * Force Away Agent
   * @param userId      User id, who need to be force away.
   */
  public forceAwayAgent(userId: string) {
    const url = `/user/forceLogout`;

    return this.httpClient.put(url, { UserId: userId });
  }

  /**
   * updateProfilePic
   * @param data  data payload
   */
  public updateProfilePic(data: any) {
    const url = `/user/profilePic`;

    return this.httpClient.post<any>(url, data);
  }

  /**
   * getProfilePic
   */
  public getProfilePic() {
    const url = `/user/profilePic`;

    return this.httpClient.get<{ ProfilePic: any }>(url, this.defaultReqOptions);
  }

  /**
   * All Feature Related Work Start
   */

  /**
   * getAllFeatures
   */
  public getAllFeatures(): Observable<Array<FeatureResponse>> {
    const url = `/feature`;

    return this.httpClient.get<Array<FeatureResponse>>(url);
  }

  /**
   * getAllFeaturesListByRoleID
   */
  public getFeaturesByRoleId(id: string): Observable<Array<string>> {
    const url = `/role/featuresList/${id}`;

    return this.httpClient.get<Array<string>>(url);
  }

  mapListSelectedFeatureIds(nodes: Array<FeaturesList>) {
    nodes.forEach((node) => {
      // Add `isSelected` property based on matching id
      if (node.isSelected || node.isPartial) {
        this.selectedFeaturesIds.push(node.id);
      }

      // Recursively check and update children if they exist
      if (node.children && node.children.length > 0) {
        this.mapListSelectedFeatureIds(node.children);
      }
    });
  }

  convertKeysToLowerCase(array: any[]): any[] {
    return array.map((obj) => {
      return Object.keys(obj).reduce((acc: any, key) => {
        // Convert only the first letter of the key to lowercase
        const newKey = key.charAt(0).toLowerCase() + key.slice(1);
        acc[newKey] = obj[key];
        return acc;
      }, {});
    });
  }

  closeCampaignUpdateModal() {
    this.campaignUpdateModal = {
      isModalOpen: false,
      isSingleUser: false,
      isMultiUsers: false,
      userIds: [],
      userNames: [],
      clientCampaignsDropDown: [],
      agentCampaigns: [],
      supervisorCampaigns: [],
      agentCampaignsDropDown: [],
      supervisorCampaignsDropDown:[]
    };
    this.clearUsersCampaignForm();
  }

  closePriorityUpdateModal() {
    this.priorityUpdateModal = {
      isModalOpen: false,
      isSingleUser: false,
      isMultiUsers: false,
      userIds: [],
      userNames: [],
      clientCampaignsDropDown: [],
      agentCampaigns: [],
      supervisorCampaigns: [],
      agentCampaignsDropDown: [],
      supervisorCampaignsDropDown:[]
    };
    this.clearUsersPriorityForm();
  }

  openUserPasswordConfirmModal(user: any = {}) {
    this.userPasswordToBeReset = { id: user._id, firstName: user.FirstName };
    this.flecxModalService.isOpen = true;
    this.flecxModalService.isDoubbleButton = true;
    this.flecxModalService.fButtonType = 'Reset_Password_Yes';
    this.flecxModalService.sButtonType = 'Reset_Password_No';
    this.flecxModalService.fButtonText = 'Yes';
    this.flecxModalService.sButtonText = 'No';
    this.flecxModalService.text = `<p>Are you sure you want to reset the password for <strong>${user.FirstName}</strong></p>`;
  }

  openBulkCampaignUpdateModal() {
    this.resetBulkCampaignUpdateModal();
    if (!this.clientCampaigns || !this.clientCampaigns.length) {
      this.clientCampaigns = this.authService.getAllClientCampaigns() || [];
    }
    this.bulkCampaignUpdateModal.isModalOpen = true;
  }

  closeBulkCampaignUpdateModal() {
    this.resetBulkCampaignUpdateModal();
  }

  resetBulkCampaignUpdateModal() {
    this.bulkCampaignUpdateModal = {
      isModalOpen: false,
      step: 1,
      file: null,
      fileName: '',
      fileSize: '',
      totalRows: 0,
      validCount: 0,
      errorCount: 0,
      rows: [],
      skipErrors: true,
      isLoading: false,
      isValidating: false,
      summarySuccessCount: 0,
      summarySkippedCount: 0,
    };
  }

  downloadSampleCsv() {
    const csvContent = 'AgentID,Campaigns\r\nDM3,"P20,P40"\r\nDM4,P20\r\nDM5,"P38,P40"\r\n';
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'sample_agent_campaigns.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  exportErrorsCsv() {
    const errorRows = this.bulkCampaignUpdateModal.rows.filter((r) => r.status === 'error');
    if (!errorRows.length) return;
    let csvContent = 'Row,AgentID,Campaigns,Error Reason\r\n';
    errorRows.forEach((row) => {
      const rawCampaigns = `"${row.campaigns.join(',')}"`;
      const escapedMsg = `"${(row.message || '').replace(/"/g, '""')}"`;
      csvContent += `${row.rowNumber},${row.agentId},${rawCampaigns},${escapedMsg}\r\n`;
    });
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `bulk_campaign_errors_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  public parseCsvText(text: string): { headers: string[]; rows: string[][] } {
    const lines: string[] = [];
    let currentLine = '';
    let insideQuotes = false;
    const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    for (let i = 0; i < normalized.length; i++) {
      const char = normalized[i];
      if (char === '"') {
        if (insideQuotes && normalized[i + 1] === '"') {
          currentLine += '"';
          i++;
        } else {
          insideQuotes = !insideQuotes;
        }
      } else if (char === '\n' && !insideQuotes) {
        if (currentLine.trim()) {
          lines.push(currentLine);
        }
        currentLine = '';
      } else {
        currentLine += char;
      }
    }
    if (currentLine.trim()) {
      lines.push(currentLine);
    }

    if (lines.length === 0) {
      return { headers: [], rows: [] };
    }

    const parseLine = (line: string): string[] => {
      const fields: string[] = [];
      let field = '';
      let inQuote = false;
      for (let i = 0; i < line.length; i++) {
        const c = line[i];
        if (c === '"') {
          if (inQuote && line[i + 1] === '"') {
            field += '"';
            i++;
          } else {
            inQuote = !inQuote;
          }
        } else if (c === ',' && !inQuote) {
          fields.push(field.trim());
          field = '';
        } else {
          field += c;
        }
      }
      fields.push(field.trim());
      return fields;
    };

    const headers = parseLine(lines[0]).map((h) => h.replace(/^["']|["']$/g, '').trim());
    const rows = lines.slice(1).map(parseLine);
    return { headers, rows };
  }

  public stageCsvFile(file: File) {
    if (!file) return;
    if (!file.name.toLowerCase().endsWith('.csv')) {
      this.toastService.error('Please upload a valid .csv file.');
      return;
    }
    const sizeKb = (file.size / 1024).toFixed(1) + ' KB';
    this.bulkCampaignUpdateModal.file = file;
    this.bulkCampaignUpdateModal.fileName = file.name;
    this.bulkCampaignUpdateModal.fileSize = sizeKb;
    this.bulkCampaignUpdateModal.rows = [];
    this.bulkCampaignUpdateModal.totalRows = 0;
    this.bulkCampaignUpdateModal.validCount = 0;
    this.bulkCampaignUpdateModal.errorCount = 0;
    this.bulkCampaignUpdateModal.step = 1;
  }

  public removeStagedFile() {
    this.bulkCampaignUpdateModal.file = null;
    this.bulkCampaignUpdateModal.fileName = '';
    this.bulkCampaignUpdateModal.fileSize = '';
    this.bulkCampaignUpdateModal.rows = [];
    this.bulkCampaignUpdateModal.totalRows = 0;
    this.bulkCampaignUpdateModal.validCount = 0;
    this.bulkCampaignUpdateModal.errorCount = 0;
    this.bulkCampaignUpdateModal.step = 1;
  }

  public validateUploadedCsv() {
    const file = this.bulkCampaignUpdateModal.file;
    if (!file) {
      this.toastService.warning('Please select or drop a CSV file first.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const text = e.target.result as string;
      const { headers, rows } = this.parseCsvText(text);

      if (!headers.length) {
        this.toastService.error('The uploaded CSV file is empty.');
        return;
      }

      const agentIdIdx = headers.findIndex((h) => h.toLowerCase() === 'agentid');
      const campaignsIdx = headers.findIndex((h) => h.toLowerCase() === 'campaigns');

      if (agentIdIdx === -1 || campaignsIdx === -1) {
        this.toastService.error('Invalid CSV format. Header must contain "AgentID" and "Campaigns" columns.');
        return;
      }

      if (!rows.length) {
        this.toastService.error('The uploaded CSV file contains no data rows.');
        return;
      }

      const rowsPayload: Array<{
        RowNumber: number;
        AgentId: string;
        Campaigns: string[];
      }> = [];

      rows.forEach((cols, idx) => {
        const rowNumber = idx + 2; // Line 1 is header
        const rawAgent = cols[agentIdIdx] !== undefined ? cols[agentIdIdx] : '';


        const agentId = rawAgent.replace(/^["']|["']$/g, '').trim();
        const campaignCols: string[] = [];
        if (campaignsIdx >= 0) {
          if (campaignsIdx > agentIdIdx) {
            campaignCols.push(...cols.slice(campaignsIdx));
          } else {
            if (cols[campaignsIdx] !== undefined) {
              campaignCols.push(cols[campaignsIdx]);
            }
            if (cols.length > headers.length) {
              campaignCols.push(...cols.slice(headers.length));
            }
          }
        }

        const campaigns: string[] = [];
        for (const col of campaignCols) {
          if (!col) continue;
          const tokens = col.split(/[,;]+/);
          for (const token of tokens) {
            const cleaned = token.replace(/^["'\s]+|["'\s]+$/g, '').trim();
            if (cleaned && !campaigns.includes(cleaned)) {
              campaigns.push(cleaned);
            }
          }
        }

        if (!agentId && campaigns.length === 0) {
          return; // Skip completely blank row
        }






        rowsPayload.push({
          RowNumber: rowNumber,
          AgentId: agentId,
          Campaigns: campaigns,
        });
      });

      if (!rowsPayload.length) {
        this.toastService.error('No readable rows found in the CSV file.');
        return;
      }

      this.bulkCampaignUpdateModal.isValidating = true;

      this.userApisService.validateBulkUsersCampaign({ Rows: rowsPayload }).subscribe({
        next: (res: any) => {
          this.bulkCampaignUpdateModal.isValidating = false;
          const apiRows = res?.rows || res?.Rows || [];
          this.bulkCampaignUpdateModal.totalRows = res?.totalRows ?? res?.TotalRows ?? apiRows.length;
          this.bulkCampaignUpdateModal.validCount = res?.validRowsCount ?? res?.ValidRowsCount ?? 0;
          this.bulkCampaignUpdateModal.errorCount = res?.invalidRowsCount ?? res?.InvalidRowsCount ?? 0;
          this.bulkCampaignUpdateModal.rows = apiRows.map((r: any) => ({
            rowNumber: r.rowNumber ?? r.RowNumber,
            agentId: r.agentId ?? r.AgentId,
            userName: r.userName ?? r.UserName ?? '',
            campaigns: r.campaigns ?? r.Campaigns ?? [],
            status: (r.isValid ?? r.IsValid) ? 'valid' : 'error',
            message: (r.errors ?? r.Errors ?? []).join('; '),
          }));
          this.bulkCampaignUpdateModal.skipErrors = true;
          this.bulkCampaignUpdateModal.step = 2;
        },
        error: (err: any) => {
          this.bulkCampaignUpdateModal.isValidating = false;
          const msg = err?.error?.message || err?.message || 'Failed to validate CSV with server.';
          this.toastService.error(msg);
        },
      });
    };

    reader.onerror = () => {
      this.toastService.error('Failed to read the file. Please try again.');
    };

    reader.readAsText(file);
  }

  public parseAndValidateCsv(file: File) {
    this.stageCsvFile(file);
  }

  public executeBulkCampaignUpdate() {
    if (!this.bulkCampaignUpdateModal.skipErrors && this.bulkCampaignUpdateModal.errorCount > 0) {
      this.toastService.error('Please fix errors or enable "Skip invalid rows" to proceed.');
      return;
    }

    const validRows = this.bulkCampaignUpdateModal.rows.filter((r) => r.status === 'valid');
    if (!validRows.length) {
      this.toastService.warning('No valid rows to update.');
      return;
    }

    this.bulkCampaignUpdateModal.isLoading = true;

    const updates = validRows.map((row) => ({
      AgentId: row.agentId,
      Campaigns: row.campaigns,
    }));

    const payload = {
      Updates: updates,
    };

    this.userApisService.bulkUpdateUsersCampaign(payload).subscribe({
      next: (res: any) => {
        this.bulkCampaignUpdateModal.isLoading = false;
        this.bulkCampaignUpdateModal.summarySuccessCount = res?.updatedCount ?? res?.UpdatedCount ?? validRows.length;
        this.bulkCampaignUpdateModal.summarySkippedCount = this.bulkCampaignUpdateModal.errorCount;
        this.bulkCampaignUpdateModal.step = 3;
        this.toastService.success(`Successfully updated campaigns for ${validRows.length} agent(s).`);
        this.isUserListUpdated.next({ isUpdated: true });
      },
      error: (err: any) => {
        this.bulkCampaignUpdateModal.isLoading = false;
        const msg = err?.error?.message || err?.message || 'Failed to update user campaigns.';
        this.toastService.error(msg);
      },
    });
  }

  openTeamStructureModal() {
    this.resetTeamStructureModal();
    this.teamStructureModal.isModalOpen = true;
  }

  closeTeamStructureModal() {
    this.resetTeamStructureModal();
  }

  resetTeamStructureModal() {
    this.teamStructureModal = {
      isModalOpen: false,
      step: 1,
      file: null,
      fileName: '',
      fileSize: '',
      totalRows: 0,
      validCount: 0,
      errorCount: 0,
      rows: [],
      skipErrors: true,
      isLoading: false,
      isValidating: false,
      summarySuccessCount: 0,
      summarySkippedCount: 0,
    };
  }

  downloadTeamStructureSampleCsv() {
    const csvContent = 'AgentID,SupervisorFleCXID\r\nDM3,john.doe@flecx.io\r\nDM4,sarah.smith@flecx.io\r\nDM5,john.doe@flecx.io\r\n';
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'sample_team_structure.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  exportTeamStructureErrorsCsv() {
    const errorRows = this.teamStructureModal.rows.filter((r) => r.status === 'error');
    if (!errorRows.length) return;
    let csvContent = 'Row,AgentID,Agent Name,Supervisor FleCX ID,Supervisor Name,Error Reason\r\n';
    errorRows.forEach((row) => {
      const rawAgentName = `"${(row.agentName || '').replace(/"/g, '""')}"`;
      const rawSupName = `"${(row.supervisorName || '').replace(/"/g, '""')}"`;
      const escapedMsg = `"${(row.message || '').replace(/"/g, '""')}"`;
      csvContent += `${row.rowNumber},${row.agentId},${rawAgentName},${row.supervisorFleCxId},${rawSupName},${escapedMsg}\r\n`;
    });
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `team_structure_errors_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  public stageTeamStructureCsvFile(file: File) {
    if (!file) return;
    if (!file.name.toLowerCase().endsWith('.csv')) {
      this.toastService.error('Please upload a valid .csv file.');
      return;
    }
    const sizeKb = (file.size / 1024).toFixed(1) + ' KB';
    this.teamStructureModal.file = file;
    this.teamStructureModal.fileName = file.name;
    this.teamStructureModal.fileSize = sizeKb;
    this.teamStructureModal.rows = [];
    this.teamStructureModal.totalRows = 0;
    this.teamStructureModal.validCount = 0;
    this.teamStructureModal.errorCount = 0;
    this.teamStructureModal.step = 1;
  }

  public removeTeamStructureStagedFile() {
    this.teamStructureModal.file = null;
    this.teamStructureModal.fileName = '';
    this.teamStructureModal.fileSize = '';
    this.teamStructureModal.rows = [];
    this.teamStructureModal.totalRows = 0;
    this.teamStructureModal.validCount = 0;
    this.teamStructureModal.errorCount = 0;
    this.teamStructureModal.step = 1;
  }

  public validateUploadedTeamStructureCsv() {
    const file = this.teamStructureModal.file;
    if (!file) {
      this.toastService.warning('Please select or drop a CSV file first.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const text = e.target.result as string;
      const { headers, rows } = this.parseCsvText(text);

      if (!headers.length) {
        this.toastService.error('The uploaded CSV file is empty.');
        return;
      }

      const agentIdIdx = headers.findIndex((h) => h.toLowerCase() === 'agentid');
      const supervisorIdx = headers.findIndex((h) => h.toLowerCase() === 'supervisorflecxid');

      if (agentIdIdx === -1 || supervisorIdx === -1) {
        this.toastService.error('Invalid CSV format. Header must contain "AgentID" and "SupervisorFleCXID" columns.');
        return;
      }

      if (!rows.length) {
        this.toastService.error('The uploaded CSV file contains no data rows.');
        return;
      }

      const rowsPayload: Array<{
        RowNumber: number;
        AgentId: string;
        SupervisorFleCxId: string;
      }> = [];

      rows.forEach((cols, idx) => {
        const rowNumber = idx + 2;
        const rawAgent = cols[agentIdIdx] !== undefined ? cols[agentIdIdx] : '';
        const rawSupervisor = cols[supervisorIdx] !== undefined ? cols[supervisorIdx] : '';

        const agentId = rawAgent.replace(/^["']|["']$/g, '').trim();
        const supervisorFleCxId = rawSupervisor.replace(/^["']|["']$/g, '').trim();

        if (!agentId && !supervisorFleCxId) {
          return;
        }

        rowsPayload.push({
          RowNumber: rowNumber,
          AgentId: agentId,
          SupervisorFleCxId: supervisorFleCxId,
        });
      });

      if (!rowsPayload.length) {
        this.toastService.error('No readable rows found in the CSV file.');
        return;
      }

      this.teamStructureModal.isValidating = true;

      this.userApisService.validateTeamStructure({ Rows: rowsPayload }).subscribe({
        next: (res: any) => {
          this.teamStructureModal.isValidating = false;
          const apiRows = res?.rows || res?.Rows || [];
          this.teamStructureModal.totalRows = res?.totalRows ?? res?.TotalRows ?? apiRows.length;
          this.teamStructureModal.validCount = res?.validRowsCount ?? res?.ValidRowsCount ?? 0;
          this.teamStructureModal.errorCount = res?.invalidRowsCount ?? res?.InvalidRowsCount ?? 0;
          this.teamStructureModal.rows = apiRows.map((r: any) => ({
            rowNumber: r.rowNumber ?? r.RowNumber,
            agentId: r.agentId ?? r.AgentId,
            agentName: r.agentName ?? r.AgentName ?? '',
            supervisorFleCxId: r.supervisorFleCxId ?? r.SupervisorFleCxId ?? '',
            supervisorName: r.supervisorName ?? r.SupervisorName ?? '',
            status: (r.isValid ?? r.IsValid) ? 'valid' : 'error',
            message: (r.errors ?? r.Errors ?? []).join('; '),
          }));
          this.teamStructureModal.skipErrors = true;
          this.teamStructureModal.step = 2;
        },
        error: (err: any) => {
          this.teamStructureModal.isValidating = false;
          const msg = err?.error?.message || err?.message || 'Failed to validate CSV with server.';
          this.toastService.error(msg);
        },
      });
    };

    reader.onerror = () => {
      this.toastService.error('Failed to read the file. Please try again.');
    };

    reader.readAsText(file);
  }

  public executeTeamStructureUpdate() {
    if (!this.teamStructureModal.skipErrors && this.teamStructureModal.errorCount > 0) {
      this.toastService.error('Please fix errors or enable "Skip invalid rows" to proceed.');
      return;
    }

    const validRows = this.teamStructureModal.rows.filter((r) => r.status === 'valid');
    if (!validRows.length) {
      this.toastService.warning('No valid rows to update.');
      return;
    }

    this.teamStructureModal.isLoading = true;

    const updates = validRows.map((row) => ({
      AgentId: row.agentId,
      SupervisorFleCxId: row.supervisorFleCxId,
    }));

    const payload = {
      Updates: updates,
    };

    this.userApisService.bulkUpdateTeamStructure(payload).subscribe({
      next: (res: any) => {
        this.teamStructureModal.isLoading = false;
        this.teamStructureModal.summarySuccessCount = res?.updatedCount ?? res?.UpdatedCount ?? validRows.length;
        this.teamStructureModal.summarySkippedCount = this.teamStructureModal.errorCount;
        this.teamStructureModal.step = 3;
        this.toastService.success(`Successfully updated team structure for ${validRows.length} agent(s).`);
        this.isUserListUpdated.next({ isUpdated: true });
      },
      error: (err: any) => {
        this.teamStructureModal.isLoading = false;
        const msg = err?.error?.message || err?.message || 'Failed to update team structure.';
        this.toastService.error(msg);
      },
    });
  }

  //* Clean up
  ngOnDestroy(): void {
    this.subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }
}
